import { render, staticRenderFns } from "./insurance_4.vue?vue&type=template&id=2dc0c119&scoped=true&"
import script from "./insurance_4.vue?vue&type=script&lang=js&"
export * from "./insurance_4.vue?vue&type=script&lang=js&"
import style0 from "./insurance_4.vue?vue&type=style&index=0&id=2dc0c119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc0c119",
  null
  
)

export default component.exports